import React from 'react';
import { FormSpy, FormSpyProps } from 'react-final-form';
import { useDebouncedCallback } from 'use-debounce';

type Props<FormValues> = {
    onChange: NonNullable<FormSpyProps<FormValues>['onChange']>;
} & FormSpyProps<FormValues>;

export default function AutoSave<FormValues>({ onChange, subscription = { values: true }, ...rest }: Props<FormValues>) {
    const handleChange = useDebouncedCallback(onChange, 250);

    // invoking handleChange as soon as the component is cleaned up
    React.useEffect(() => {
        return () => {
            handleChange.flush();
        };
    }, []);

    return <FormSpy {...rest} subscription={subscription} onChange={handleChange} />;
}
